import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Quality from "@/pages/Quality";
import Markets from "@/pages/Markets";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import ScrollToTop from "@/components/ScrollToTop";

const TITLES = {
  "/": "EXIMXPRESS | Fresh Onions from India",
  "/about": "About Us – EXIMXPRESS",
  "/products": "Products – EXIMXPRESS",
  "/quality": "Quality – EXIMXPRESS",
  "/markets": "Global Markets – EXIMXPRESS",
  "/blog": "Blog – EXIMXPRESS",
  "/contact": "Contact Us – EXIMXPRESS",
  "/login": "Admin Login – EXIMXPRESS",
  "/admin": "Admin Dashboard – EXIMXPRESS",
};

function TitleUpdater() {
  const location = useLocation();
  useEffect(() => {
    const title = TITLES[location.pathname] || "EXIMXPRESS | Fresh Onions from India";
    document.title = title;
    // Guard against external scripts overwriting the title
    const interval = setInterval(() => {
      if (document.title !== title) document.title = title;
    }, 500);
    return () => clearInterval(interval);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TitleUpdater />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="products" element={<Products />} />
            <Route path="quality" element={<Quality />} />
            <Route path="markets" element={<Markets />} />
            <Route path="blog" element={<Blog />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
